import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProfileState } from './profile.reducer';
import { RequestStatus } from '../../enums/request-status.enum';

export const selectProfileState = createFeatureSelector<ProfileState>('profile');

export const selectProfile = createSelector(
  selectProfileState,
  (state) => state.data
);

export const selectDefaultDomainUuid = createSelector(
  selectProfile,
  (profile) => profile?.defaultDomainUuid || null
);

export const selectProfileStatus = createSelector(
  selectProfileState,
  (state) => state.status
);

export const selectProfileLoading = createSelector(
  selectProfileStatus,
  (status) => status === RequestStatus.Loading
);

export const selectProfileLoaded = createSelector(
  selectProfileStatus,
  (status) => status === RequestStatus.Success
);

export const selectUpdateStatus = createSelector(
  selectProfileState,
  (state) => state.updateStatus
);

export const selectIsUpdating = createSelector(
  selectUpdateStatus,
  (status) => status === RequestStatus.Loading
);

export const selectUpdateSuccess = createSelector(
  selectUpdateStatus,
  (status) => status === RequestStatus.Success
);

export const selectDepartments = createSelector(
  selectProfileState,
  (state) => state.data?.departments || []
);

export const selectDepartmentsLoading = createSelector(
  selectProfileState,
  (state) => state.departmentsStatus === RequestStatus.Loading
);

export const selectTimezones = createSelector(
  selectProfileState,
  (state) => state.data?.timezones || []
);

export const selectTimezonesLoading = createSelector(
  selectProfileState,
  (state) => state.timezonesStatus === RequestStatus.Loading
);

export const selectRegenerateTokenStatus = createSelector(
  selectProfileState,
  (state) => state.regenerateTokenStatus
);

export const selectIsRegeneratingToken = createSelector(
  selectRegenerateTokenStatus,
  (status) => status === RequestStatus.Loading
);

export const selectUploadPhotoStatus = createSelector(
  selectProfileState,
  (state) => state.uploadPhotoStatus
);

export const selectIsUploadingPhoto = createSelector(
  selectUploadPhotoStatus,
  (status) => status === RequestStatus.Loading
);

export const selectProfileError = createSelector(
  selectProfileState,
  (state) => state.error
);
